import React, { useCallback, useMemo } from 'react'

import TabButtonsGroup from 'LuxKit/Tabs/TabButtonsGroup'
import TabButton from 'LuxKit/Tabs/TabButton'
import styled from 'styled-components'
import { rem } from 'polished'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import setSelectedBusinessTravellersAndGuests from 'actions/businessTraveller/setSelectedBusinessTravellerEmployeesAndGuests'
import { saveBusinessTravellerSelectedTravellerState } from 'businessTraveller/storage/businessTravellerStorage'
import { getBusinessTravellerSelectEnabled } from 'businessTraveller/utils/getBusinessTravellerSelectEnabled'

export interface GlobalSearchTab {
  key: App.SearchVertical
  label: string
}

const StyledTabButtonsGroup = styled(TabButtonsGroup)`
  padding: 0 ${rem(16)};
`

interface Props {
  selectedTabKey: App.SearchVertical
  tabs: Map<App.SearchVertical, App.GlobalSearchVerticalTab>
  onTabSelect?: (selectedTab: App.SearchVertical) => void
}

function GlobalSearchTabs(props: Props) {
  const { selectedTabKey, tabs, onTabSelect } = props
  const tabsArray = useMemo(() => [...tabs.entries()], [tabs])
  const dispatch = useAppDispatch()
  const isBusinessTravellerSelectEnabled = useAppSelector(state => getBusinessTravellerSelectEnabled(state.businessTraveller.currentBusinessAccount))

  const handleTabClick = useCallback((key: App.SearchVertical) => {
    if (isBusinessTravellerSelectEnabled) {
      // Reset traveller selection when switching between tabs and only if the current business account is an admin or manager
      // Keep only the first employee (the user themselves) and reset guest count to 0
      dispatch(setSelectedBusinessTravellersAndGuests([], 0))
      // Update the local storage
      saveBusinessTravellerSelectedTravellerState([], 0)
    }

    // Call the parent's onTabSelect callback
    onTabSelect?.(key)
  }, [dispatch, onTabSelect, isBusinessTravellerSelectEnabled])

  return <StyledTabButtonsGroup>
    {tabsArray.map(([key, { label, Icon }]) => <TabButton
      size="medium"
      key={key}
      isActive={selectedTabKey === key}
      onClick={() => handleTabClick(key)}
      startIcon={<Icon />}
      format="propercase"
    >
      {label}
    </TabButton>)}
  </StyledTabButtonsGroup>
}

export default GlobalSearchTabs
